import { SpecialSymbolType } from '@/containers/symbols/SpecialSymbolType'
import { SymbolType } from '@/containers/symbols/SymbolType'

export const SYMBOL_KEY_TO_ID: Record<string, number> = {
    a: SymbolType.HP_1,
    b: SymbolType.HP_2,
    c: SymbolType.HP_3,
    d: SymbolType.HP_4,
    e: SymbolType.LP_1,
    f: SymbolType.LP_2,
    g: SymbolType.LP_3,
    h: SymbolType.LP_4,
    i: SymbolType.LP_5,
    j: SpecialSymbolType.MULTIPLIER,
    k: SpecialSymbolType.MULTIPLIER,
    l: SpecialSymbolType.MULTIPLIER,
    m: SpecialSymbolType.MULTIPLIER,
    n: SpecialSymbolType.MULTIPLIER,
    o: SpecialSymbolType.MULTIPLIER,
    p: SpecialSymbolType.MULTIPLIER,
    q: SpecialSymbolType.MULTIPLIER,
    r: SpecialSymbolType.MULTIPLIER,
    s: SpecialSymbolType.SCATTER,
    t: SpecialSymbolType.MULTIPLIER,
    u: SpecialSymbolType.MULTIPLIER,
    v: SpecialSymbolType.MULTIPLIER,
    w: SpecialSymbolType.MULTIPLIER,
}

export const SYMBOL_KEY_TO_MULTIPLIER: Record<string, number> = {
    j: 2,
    k: 2,
    l: 3,
    m: 4,
    n: 5,
    o: 6,
    p: 8,
    q: 10,
    r: 15,
    t: 20,
    u: 25,
    v: 50,
    w: 100,
}
